import { Row, Col } from "react-bootstrap";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useNavigation } from "utils/navigate";
import { HELP_CENTER_PATH } from "features/HelpCenter/routes";
import { ProfileContainer, TabContainer, TabButton } from "./Profile.styles";
import { userDetailSelect } from "Layout/slice/selector";
import { Heading } from "style/components/Heading.styles";
import ProfileDetailsHeader from "../ProfileDetailsHeader";
import { togglePurchasePlanModal } from "Layout/slice/index";
import { Security } from "../Security";
import { PlanAndBilling } from "../PlanAndBilling";
import { Support } from "../Support";
import { Documents } from "../Documents";
import { ProfileModal } from "./ProfileModal";

const tabOptions = [
  {
    key: "Billing",
    name: "Billing",
  },
  {
    key: "Security",
    name: "Security",
  },
  {
    key: "Documents",
    name: "Documents",
  },
  {
    key: "Support",
    name: "Support",
  },
];

export const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector(userDetailSelect);

  const { navigateToHelpCenter } = useNavigation();

  const [showProfileModal, setShowProfileModal] = useState(false);
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("activeTab") || "Billing";

  const setActiveTab = (tabKey) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set("activeTab", tabKey);
    navigate({ search: newSearchParams.toString() }, { replace: true });
  };

  const handleContactUs = () => {
    const options = {
      pathname: HELP_CENTER_PATH,
      search: `?activeTab=contactUs`,
    };
    navigateToHelpCenter(options);
  };

  const handleUpgradePlan = () => {
    dispatch(togglePurchasePlanModal(true));
  };

  return (
    <ProfileContainer>
      <div className="account-information">
        <ProfileDetailsHeader onEditClick={() => setShowProfileModal(true)} />
        <TabContainer>
          {tabOptions.map((tab) => (
            <TabButton
              key={tab.key}
              active={activeTab === tab.key}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.name}
            </TabButton>
          ))}
        </TabContainer>
        {user !== null && (
          <Row>
            <Col>
              {activeTab === "Billing" && <PlanAndBilling />}

              {activeTab === "Security" && <Security />}

              {activeTab === "Documents" && <Documents />}

              {activeTab === "Support" && (
                <section>
                  <Support />
                </section>
              )}

              {/* Close Account */}
              <section className="d-none">
                <Heading className="mt-5">Close Account</Heading>
                <div className="divider mt-1 mb-4"></div>

                <div className="close-account">
                  To close your account and delete your data,{" "}
                  <span className="link" onClick={handleContactUs}>
                    contact us.
                  </span>
                </div>
              </section>

              {user.surmount_plan?.monthly_price === 0 &&
                user.surmount_plan?.yearly_price === 0 && (
                  <div className="subscribe-plan d-none">
                    You are currently on a free plan to subscribe premium{" "}
                    <span className="link" onClick={handleUpgradePlan}>
                      click here
                    </span>
                  </div>
                )}
            </Col>
          </Row>
        )}
      </div>

      <ProfileModal
        show={showProfileModal}
        onHide={() => setShowProfileModal(false)}
      />
    </ProfileContainer>
  );
};
